import { BlockConfigItem, BlockState } from "./BlocksControl.model";

export class BlocksControlUtils {

  static getBlocksConfig(blocks: BlockState): BlockConfigItem[] {
    return [
      { key: 'channelLocks0', text: "Блокировка канала 1", value: blocks?.channelLocks?.[0], category: 'channel' },
      { key: 'channelLocks1', text: "Блокировка канала 2", value: blocks?.channelLocks?.[1], category: 'channel' },
      { key: 'channelLocks2', text: "Блокировка канала 3", value: blocks?.channelLocks?.[2], category: 'channel' },
      { key: 'channelLocks3', text: "Блокировка канала 4", value: blocks?.channelLocks?.[3], category: 'channel' },
      { key: 'syncLock', text: "Блокировка синхронизации", value: blocks.syncLock, category: 'system' },
      { key: 'timeRelaysLock', text: "Блокировка реле по времени", value: blocks.timeRelaysLock, category: 'system' },
      { key: 'astronomicalRelayLock', text: "Блокировка астрономического реле", value: blocks.astronomicalRelayLock, category: 'system' },
      { key: 'scheduleLock', text: "Блокировка расписания", value: blocks.scheduleLock, category: 'system' },
      { key: 'newYearChimesLock', text: "Блокировка новогоднего боя", value: blocks.newYearChimesLock, category: 'melody' },
      { key: 'clockChimesLock', text: "Блокировка боя часов", value: blocks.clockChimesLock, category: 'melody' },
    ];
  }

  static getTooltipText(blockText: string): string {
    switch(blockText) {
      case "Блокировка синхронизации":
        return "Первичные часы";

      case "Блокировка канала 1":
      case "Блокировка канала 2":
      case "Блокировка канала 3":
      case "Блокировка канала 4":
        return "Вторичные часы";

      case "Блокировка расписания":
      case "Блокировка реле по времени":
      case "Блокировка астрономического реле":
        return "Настройка Реле";

      case "Блокировка боя часов":
      case "Блокировка новогоднего боя":
        return "Бой часов";

      default:
        return '';
    }
  };

}
